export default [
  
  {
    header: 'Configurações',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Cadastro Operadores',
        route: 'operator',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'pcp',
      },
      {
        title: 'Centros de Trabalho',
        route: 'workcenters',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'operator',
      },    
    ]
  },
]
